import axios from "../config/axios-kb"


export const MetadataRepository = {
  getByKnowledgeItemId: (knowledgeItemId) => {
    return axios.get(`/api/knowledge/${knowledgeItemId}/metadata`);
  },
  deleteById: (id) => {
    return axios.delete(`/api/metadata/${id}`)
  },
  addMetadataToKnowledgeItemId: (data) => {
    return axios.post(`/api/metadata`, data);
  }
}